import { trpc } from '@/lib/trpc';

const STALE = 5 * 60 * 1000;

export const useInternalAdoption = (days: 7 | 30) =>
  trpc.internal.adoption.useQuery({ days }, { staleTime: STALE });

export const useInternalBrainAdoption = (days: 7 | 30) =>
  trpc.internal.brainAdoption.useQuery({ days }, { staleTime: STALE });

export const useInternalTraffic = () =>
  trpc.internal.traffic.useQuery(undefined, { staleTime: 60 * 1000, refetchInterval: 5 * 60 * 1000 });

export const useInternalAccessLog = (input: {
  day: string;
  userEmail?: string;
  module?: string;
  cursor?: string;
  limit?: number;
}) =>
  trpc.internal.accessLog.useQuery(input, {
    staleTime: 60 * 1000,
    // react-query v5: mantiene la página anterior visible mientras carga la nueva
    placeholderData: (prev) => prev,
  });

// 02/10/2026: 5 min como traffic (era 60 s). Los dos polls del panel están en BACKGROUND_PATHS: no son uso.
export const useInternalHealth = () =>
  trpc.internal.health.useQuery(undefined, { staleTime: 60 * 1000, refetchInterval: 5 * 60 * 1000 });
